import React from "react";
import Brand1 from '../img/team-1.jpg'; // Reusing images as brand logos
import Brand2 from '../img/team-2.jpg';
import Brand3 from '../img/team-3.jpg';
import Brand4 from '../img/team-4.jpg';

const Team = () => {
    return (
        <div class="container-fluid team py-5">
            <div class="container py-5">
                <div class="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: "800px"}}>
                    <h4 class="text-primary">Brand Collaborations</h4>
                    <h1 class="display-4 mb-4">Our Successful Partnerships</h1>
                    <p class="mb-0">
                        We've partnered with leading brands to create authentic, engaging campaigns that deliver results. 
                        Here are some of our recent collaborations and their performance metrics.
                    </p>
                </div>
                <div class="row gy-5 gy-lg-4 gx-4">
                    {/* Brand Collaboration 1 */}
                    <div class="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.2s">
                        <div class="team-item">
                            <div class="team-img">
                                <img src={Brand1} class="img-fluid w-100" alt="Nike Collaboration"/>
                                <div class="team-icon">
                                    <a href="#nike-case" class="btn btn-primary btn-sm-square"><i class="fas fa-chart-line"></i></a>
                                    <a href="https://instagram.com/p/nike-collab" class="btn btn-primary btn-sm-square"><i class="fab fa-instagram"></i></a>
                                    <a href="#nike-details" class="btn btn-primary btn-sm-square"><i class="fas fa-info"></i></a>
                                </div>
                            </div>
                            <div class="team-content">
                                <h4>Nike</h4>
                                <p class="mb-0">
                                    <strong>Campaign:</strong> #JustDoIt Challenge<br/>
                                    <strong>Results:</strong> 2.4M impressions, 18% engagement
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Brand Collaboration 2 */}
                    <div class="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.4s">
                        <div class="team-item">
                            <div class="team-img">
                                <img src={Brand2} class="img-fluid w-100" alt="Gymshark Collaboration"/>
                                <div class="team-icon">
                                    <a href="#gymshark-case" class="btn btn-primary btn-sm-square"><i class="fas fa-chart-line"></i></a>
                                    <a href="https://instagram.com/p/gymshark-collab" class="btn btn-primary btn-sm-square"><i class="fab fa-instagram"></i></a>
                                    <a href="#gymshark-details" class="btn btn-primary btn-sm-square"><i class="fas fa-info"></i></a>
                                </div>
                            </div>
                            <div class="team-content">
                                <h4>Gymshark</h4>
                                <p class="mb-0">
                                    <strong>Campaign:</strong> New Collection Launch<br/>
                                    <strong>Results:</strong> 1.8M reach, 12% CTR
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Brand Collaboration 3 */}
                    <div class="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.6s">
                        <div class="team-item">
                            <div class="team-img">
                                <img src={Brand3} class="img-fluid w-100" alt="MyProtein Collaboration"/>
                                <div class="team-icon">
                                    <a href="#myprotein-case" class="btn btn-primary btn-sm-square"><i class="fas fa-chart-line"></i></a>
                                    <a href="https://instagram.com/p/myprotein-collab" class="btn btn-primary btn-sm-square"><i class="fab fa-instagram"></i></a>
                                    <a href="#myprotein-details" class="btn btn-primary btn-sm-square"><i class="fas fa-info"></i></a>
                                </div>
                            </div>
                            <div class="team-content">
                                <h4>MyProtein</h4>
                                <p class="mb-0">
                                    <strong>Campaign:</strong> Product Review Series<br/>
                                    <strong>Results:</strong> 35K conversions, $120K revenue
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Brand Collaboration 4 */}
                    <div class="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.8s">
                        <div class="team-item">
                            <div class="team-img">
                                <img src={Brand4} class="img-fluid w-100" alt="Adidas Collaboration"/>
                                <div class="team-icon">
                                    <a href="#adidas-case" class="btn btn-primary btn-sm-square"><i class="fas fa-chart-line"></i></a>
                                    <a href="https://instagram.com/p/adidas-collab" class="btn btn-primary btn-sm-square"><i class="fab fa-instagram"></i></a>
                                    <a href="#adidas-details" class="btn btn-primary btn-sm-square"><i class="fas fa-info"></i></a>
                                </div>
                            </div>
                            <div class="team-content">
                                <h4>Adidas</h4>
                                <p class="mb-0">
                                    <strong>Campaign:</strong> Event Appearance<br/>
                                    <strong>Results:</strong> 500+ attendees, 3.2M social impressions
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Additional Brand Info Section */}
                <div class="row mt-5 wow fadeInUp" data-wow-delay="0.2s">
                    <div class="col-12">
                        <div class="bg-dark p-5 rounded">
                            <h3 class="text-primary mb-4">More About Our Collaborations</h3>
                            <div class="row">
                                <div class="col-md-6">
                                    <h5 class="text-white">Campaign Types</h5>
                                    <ul class="text-white">
                                        <li>Sponsored Posts & Stories</li>
                                        <li>Product Reviews & Unboxings</li>
                                        <li>Brand Ambassador Programs</li>
                                        <li>Event Appearances & Hosting</li>
                                        <li>Long-Term Partnerships</li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <h5 class="text-white">Case Studies</h5>
                                    <ul class="text-white">
                                        <li><a href="#nike-case" class="text-primary">Nike: 300% ROI Campaign</a></li>
                                        <li><a href="#gymshark-case" class="text-primary">Gymshark: Viral Launch Strategy</a></li>
                                        <li><a href="#myprotein-case" class="text-primary">MyProtein: Conversion Success</a></li>
                                        <li><a href="#adidas-case" class="text-primary">Adidas: Event Activation</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="text-center mt-4">
                                <a href="#contact" class="btn btn-primary py-3 px-5"> <span>Partner With Us</span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Team;